import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "g-sticky-bar",
    ref: "elStickyBar"
};
const _hoisted_2 = { class: "icon" };
const _hoisted_3 = { class: "caption" };
const _hoisted_4 = {
    key: 0,
    class: "caption-primary"
};
const _hoisted_5 = {
    key: 1,
    class: "caption-secondary"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_link = _resolveComponent("g-link");
    const _directive_click_outside = _resolveDirective("click-outside");
    return (_ctx.barObject?.items)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.barObject.items, (item) => {
                return (_openBlock(), _createBlock(_component_g_link, {
                    src: item.link?.src,
                    target: item.link?.target,
                    class: _normalizeClass(['link', item.class, item === _ctx.activeItem ? 'active' : '']),
                    onLinkClick: ($event) => (_ctx.onActivate(item, $event))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_g_icon, {
                                src: item.icon,
                                class: "icon-svg"
                            }, null, 8, ["src"])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            (item.caption)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.caption), 1))
                                : _createCommentVNode("", true),
                            (item.subCaption)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.subCaption), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 2
                }, 1032, ["src", "target", "class", "onLinkClick"]));
            }), 256))
        ])), [
            [_directive_click_outside, _ctx.onDeactivate]
        ])
        : _createCommentVNode("", true);
}
